/**
 * MetersHUD - Abstract meter display
 */
import React from 'react';
import { motion } from 'framer-motion';

const MetersHUD = ({ meters }) => {
  const meterConfig = [
    { key: 'stability', label: 'Stability', icon: '🏛️' },
    { key: 'momentum', label: 'Momentum', icon: '📈' },
    { key: 'knowledge', label: 'Knowledge', icon: '📚' },
    { key: 'optionality', label: 'Optionality', icon: '✨' },
    { key: 'risk_exposure', label: 'Risk', icon: '⚡' }
  ];

  return (
    <div className="fixed top-4 left-4 right-4 z-50">
      <div className="border border-hairline bg-bone-raised rounded-lg p-4">
        <div className="flex gap-4 justify-center flex-wrap">
          {meterConfig.map((config) => {
            const value = meters[config.key] || 50;

            return (
              <div key={config.key} className="flex items-center gap-2 min-w-[120px]">
                <span className="text-lg" aria-hidden="true">
                  {config.icon}
                </span>
                <div className="flex-1">
                  <div className="text-label text-secondary mb-1">{config.label}</div>
                  <div className="h-2 bg-bone border border-hairline rounded-sm overflow-hidden">
                    <motion.div
                      className="h-full bg-pine"
                      initial={{ width: 0 }}
                      animate={{ width: `${value}%` }}
                      transition={{ duration: 0.5 }}
                    />
                  </div>
                  <div className="text-label text-primary mt-1 text-right figure">
                    {Math.round(value)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MetersHUD;
